export class Todo {
  public desc: string;
  public id: number;
  public category_title	: string;
  public user_id	: any;
}
